import React, { useEffect, useState } from "react";
import { EmployeeContext } from "./EmployeeContext.jsx";
import { getCurEmployee } from "../api/EmployeeApi";
import { toast } from "react-toastify";
import {useNavigate} from "react-router-dom";

export const EmployeeProvider = ({ children }) => {
    const navigate = useNavigate();
    const [employee, setEmployee] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchEmployee = async () => {
            try {
                const res = await getCurEmployee();
                setEmployee(res.data);
            } catch (err) {
                toast.error( err?.response?.data?.message ||"Ошибка при получении данных сотрудника");
                navigate('/admin/auth')
            } finally {
                setLoading(false);
            }
        };

        fetchEmployee();
    }, []);

    return (
        <EmployeeContext.Provider value={{ employee, loading }}>
            {children}
        </EmployeeContext.Provider>
    );
};
